import type React from 'react';

import InputError from '../InputError';
import InputHelp from '../InputHelp';
import { LinkButton } from '../LinkButton';
import Loader from '../Loader';
import { Label, Value, ValueWrapper, Wrapper } from './wrapper';

interface InputStaticValueActionProps {
  label: string;
  title?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

interface InputStaticValueProps {
  label: string;
  value: string | React.ReactNode;
  help?: string;
  error?: string;
  disabled?: boolean;
  action?: InputStaticValueActionProps;
}

const InputStaticValue = ({
  label,
  value,
  help,
  error,
  disabled,
  action,
}: InputStaticValueProps) => (
  <>
    <Wrapper $error={!!error} $disabled={disabled}>
      <Label>{label}</Label>
      <ValueWrapper>
        <Value>{value}</Value>
        {action && (
          <LinkButton
            $disabled={action.disabled}
            onClick={action.disabled ? undefined : action.onClick}
            title={action.title ? action.title : action.label}
            $size="small"
            $tone="main"
            $underline
            $noWrap
          >
            {action.label}
            {action.loading && <Loader inline />}
          </LinkButton>
        )}
      </ValueWrapper>
    </Wrapper>
    {help && <InputHelp disabled={disabled}>{help}</InputHelp>}
    {error && <InputError>{error}</InputError>}
  </>
);

export default InputStaticValue;
